import React from "react";
import { Card, Row, Col, Image, Table } from "react-bootstrap";
import SeaRoadBrand from '../assets/img/brand/sea-road-dark.png';
import moment from 'moment-timezone';
import { formatCurrency } from "../utils/formatter";

const CbmRateCountsPreview = (props) => {
    const { 
        startDate, 
        endDate, 
        reportList, 
        overallTotalCBM, 
        overallTotalBillableAmount,
    } = props;

    const formattedStartDate = startDate ? moment(startDate).format('YYYY-MM-DD') : '';
    const formattedEndDate = endDate ? moment(endDate).format('YYYY-MM-DD') : '';

    return (
        <Card className="bg-white shadow-sm mb-4" style={{width: '100%'}}>
            <Card.Body>
                <Row>
                    <Col md="12">
                        <div className="preview-container">
                            <div className="preview-header">
                                <Image src={SeaRoadBrand} className="navbar-brand-light" alt="SEA ROAD TRADING INC." />
                                <div className="company-info">
                                    <h2>SEA ROAD TRADING INC.</h2>
                                    <p>Gochan Compound, Warehouse 5B, MJ Cuenco Avenue, Mabolo, Cebu City, Philippines</p>
                                    <p>Telephone No.: (032) 434-6453 | TIN#: 274-454-701-000</p>
                                </div>
                            </div>
                            <div className="border-line-up"></div>
                            <div className="border-line-down"></div>
                        </div>
                    </Col>
                </Row>
                <div className="preview-body clearfix mb-5">
                    <h1>Rate Counts (With Total CBM, Amount & Percentage) Report</h1>
                    <div className="left">
                        <p>Start Date: <b>{formattedStartDate}</b></p>
                        <p>End Date: <b>{formattedEndDate}</b></p>
                    </div>
                </div>
                <Table hover className="billing-table-list align-items-center">
                    <thead>
                        <tr>
                        <th className="border-bottom">Client Name</th>
                            <th className="border-bottom">Total CBM</th>
                            <th className="border-bottom">Gross Amount</th>
                            <th className="border-bottom">Total Additional Amount</th>
                            <th className="border-bottom">Total Billable Amount</th>
                            <th className="border-bottom">CBM Percentage</th>
                            <th className="border-bottom">Billable Amount Percentage</th>
                            <th className="border-bottom">Applied Rate</th>
                            <th className="border-bottom">Approved Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {reportList.map((item, index) => (
                            <tr key={index}>
                                <td>
                                    <span className="fw-normal">{item.clientDisplayName}</span>
                                </td>
                                <td>
                                    <span className="fw-normal">{parseFloat(item.totalCBM).toFixed(2)}</span>
                                </td>
                                <td>
                                    <span className="fw-normal">{formatCurrency(parseFloat(item.grossAmount)) || 0.00}</span>
                                </td>
                                <td>
                                    <span className="fw-normal">{formatCurrency(parseFloat(item.totalAdditionalAmount)) || 0.00}</span>
                                </td>
                                <td>
                                    <span className="fw-normal">{formatCurrency(parseFloat(item.totalBillableAmount)) || 0.00}</span>
                                </td>
                                <td>
                                    <span className="fw-normal">{item.cbmPercentage}</span>
                                </td>
                                <td>
                                    <span className="fw-normal">{item.amountPercentage}</span>
                                </td>
                                <td>
                                    <span className="fw-normal">{formatCurrency(parseFloat(item.appliedRate)) || 0.00}</span>
                                </td>
                                <td>
                                    <span className="fw-normal">{moment(item.createdDate).format('YYYY-MM-DD')}</span>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
                <div className="mt-4">
                    <Row>
                        <Col md={6}>
                            <h4><strong>Overall Total CBM:</strong> {parseFloat(overallTotalCBM).toFixed(2)}</h4>
                        </Col>
                        <Col md={6}>
                            <h4><strong>Overall Total Billable Amount:</strong> {formatCurrency(parseFloat(overallTotalBillableAmount)) || 0.00}</h4>
                        </Col>
                    </Row>
                </div>
            </Card.Body>
        </Card>
    )
}

export default CbmRateCountsPreview;